import { enableScrolling, disableScrolling } from '../utils/helpers';

class Header {
  constructor(wWidth) {
    this.wWidth = wWidth;
    this.scrollTrigger = 50;
    this.headerOpened = false;
    this.$container = $('.header');
    this.$hamburger = this.$container.find('.hamburger');

    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.$hamburger.on('click', this.toggleHeader.bind(this));
  }

  toggleHeader() {
    if (this.headerOpened) {
      this.closeHeader();
    } else {
      this.openHeader();
    }
  }

  openHeader() {
    this.$container.addClass('is-opened');
    this.headerOpened = true;
    disableScrolling();
  }

  closeHeader() {
    this.$container.removeClass('is-opened');
    this.headerOpened = false;
    enableScrolling();
  }

  onScroll() {
    const st = $(window).scrollTop();

    if (st > this.scrollTrigger) {
      this.$container.addClass('is-scrolling');
    } else {
      this.$container.removeClass('is-scrolling');
    }
  }

  onResize(wWidth) {
    this.wWidth = wWidth;

    if (this.wWidth > 1023 && this.headerOpened) {
      this.closeHeader();
    }
  }
}

export default Header;
